import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md', // Esto le dice que busque clases .mdi
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#607D8B',
        secondary: '#CFD8DC',
        accent: '#448AFF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
});
